import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  petInfoDetail: {},
  breedList: [],
};

export default function petEdit(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 宠物品种列表
    case ACTION_TYPES.GET_BREED_LIST:
      result.breedList = payload;
      break;
    // 宠物详情
    case ACTION_TYPES.GET_MEM_PET_INFO:
      result.petInfoDetail = payload;
      break;
    default:
      result = state;
  }
  return result;
}
